/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_First_TitleInputs */

const en_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to first event`)
};

const fr_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au premier evenement`)
};

const de_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zum ersten Ereignis`)
};

const it_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai al primo evento`)
};

const ru_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к первому событию`)
};

const es_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al primer evento`)
};

const zh_cn2_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往第一个活动`)
};

const ja_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のイベントへ移動`)
};

const hi_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले इवेंट पर जाएं`)
};

const pt_pt2_video_export_preview_go_to_first_title = /** @type {(inputs: Video_Export_Preview_Go_To_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vá para o primeiro evento.`)
};

/**
* | output |
* | --- |
* | "Go to first event" |
*
* @param {Video_Export_Preview_Go_To_First_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_first_title = /** @type {((inputs?: Video_Export_Preview_Go_To_First_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_First_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_go_to_first_title(inputs)
	if (locale === "de") return de_video_export_preview_go_to_first_title(inputs)
	if (locale === "it") return it_video_export_preview_go_to_first_title(inputs)
	if (locale === "ru") return ru_video_export_preview_go_to_first_title(inputs)
	if (locale === "es") return es_video_export_preview_go_to_first_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_go_to_first_title(inputs)
	if (locale === "ja") return ja_video_export_preview_go_to_first_title(inputs)
	if (locale === "hi") return hi_video_export_preview_go_to_first_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_go_to_first_title(inputs)
	return en_video_export_preview_go_to_first_title(inputs)
});